import APIS from "../constant/EndPoint";
import useGetHook from "./useGetHook";
interface IUsePostHook {
  allowedPermissions: string[];
}
const usePermission = (props: IUsePostHook) => {
  const { allowedPermissions } = props;
  const { data, isLoading } = useGetHook({
    queryKey: [`user-profile`],
    url: `${APIS.USER}me/`,
    params: {},
  });
  if (data?.is_superuser) {
    return true;
  }
  const permissionsLists: any =
    data && data?.groups?.map((item: any) => item.custom_permissions).flat();
  let isAllowed: boolean = permissionsLists?.some(
    (permission: any) =>
      allowedPermissions.includes(permission) ||
      allowedPermissions.includes("no-permission-required")
  );
  return isAllowed;
};

export default usePermission;
